import {Portal, Select} from "@chakra-ui/react";
import React from "react";

const ScenarioSelect = ({
                            collection,
                            selectedScenario,
                            scenarios,
                            onScenarioChange,
                            size = 'md',
                            maxW = '320px'
                        }) => {
    return (
        <Select.Root
            collection={collection}
            value={selectedScenario ? [selectedScenario.id] : []}
            size={size}
            onValueChange={(e) => {
                const id = e.value[0];
                const scenario = scenarios.find(s => s.id === id) ?? null;
                onScenarioChange(scenario);
            }}
            maxW={maxW}
        >
            <Select.HiddenSelect/>
            <Select.Control>
                <Select.Trigger>
                    <Select.ValueText placeholder="Select a scenario..." color="text.user"/>
                </Select.Trigger>
                <Select.IndicatorGroup>
                    <Select.Indicator/>
                </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
                <Select.Positioner>
                    <Select.Content>
                        {collection.items.map(item => (
                            <Select.Item item={item} key={item.value} color="text.user">
                                {item.label}
                                <Select.ItemIndicator/>
                            </Select.Item>
                        ))}
                    </Select.Content>
                </Select.Positioner>
            </Portal>
        </Select.Root>
    )
}

export default ScenarioSelect;